import Splide from '@splidejs/splide';

// Selectors handled here — excluded from the generic .splide init in main.js
export const CUSTOM_SLIDESHOW_SELECTORS = [
  '.hp-hero__slideshow',
  '.hp-gallery__main',
  '.hp-gallery__thumbs',
];

// Hero — full-bleed crossfade behind the headline. Splide's default
// reducedMotion option pauses autoplay for prefers-reduced-motion users.
function initHeroSlideshow() {
  const el = document.querySelector('.hp-hero__slideshow');
  if (!el) return;

  new Splide(el, {
    type: 'fade',
    rewind: true,
    speed: 1200,
    autoplay: true,
    interval: 6000,
    pauseOnHover: false,
    arrows: false,
    pagination: true,
    drag: false,
  }).mount();
}

// Gallery — main slider synced with a clickable thumbnail strip
function initGallerySlideshow() {
  const mainEl = document.querySelector('.hp-gallery__main');
  const thumbsEl = document.querySelector('.hp-gallery__thumbs');
  if (!mainEl || !thumbsEl) return;

  const main = new Splide(mainEl, {
    type: 'fade',
    rewind: true,
    speed: 500,
    pagination: false,
    lazyLoad: 'nearby',
    keyboard: 'focused',
    // Slower than the hero (6s); pauses while hovered or focused.
    // Starts paused — playback begins once the gallery scrolls into view.
    autoplay: 'pause',
    interval: 8000,
    pauseOnHover: true,
    pauseOnFocus: true,
  });

  const thumbs = new Splide(thumbsEl, {
    fixedWidth: 120,
    fixedHeight: 80,
    gap: '0.5rem',
    rewind: true,
    pagination: false,
    arrows: false,
    isNavigation: true,
    focus: 'center',
    lazyLoad: 'nearby',
    breakpoints: {
      767.98: { fixedWidth: 80, fixedHeight: 54 },
    },
  });

  const counter = mainEl.querySelector('.hp-gallery__counter-current');
  main.on('mounted move', () => {
    if (counter) counter.textContent = main.index + 1;
  });

  main.sync(thumbs);
  main.mount();
  thumbs.mount();

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      main.Components.Autoplay.play();
      observer.disconnect();
    }
  }, { threshold: 0.4 });
  observer.observe(mainEl);
}

export function initSlideshows() {
  initHeroSlideshow();
  initGallerySlideshow();
}
